// extracted by mini-css-extract-plugin
export default {"h":"Products_h__s+xkx"};